(() => {
  if (!/^fr(?:-|$)/i.test(document.documentElement.lang) || !window.wfI18n) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const translate = window.wfI18n;
  const widgetSelector = '.jdgm-widget, .jm-review-widget, .jdgm-medals';
  const metadataSelector = '.jdgm-rev__prod-link, .jm-product-variant-card__product-link';
  const observedWidgets = new WeakSet();
  const pendingWidgets = new Set();
  let products, productsRequest, pending = false;
  const source = document.querySelector('[data-wf-french-reviews]');
  const routeRoot = source?.dataset.root?.replace(/\/?$/, '/') || '/fr/';

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }
  function label(text) {
    for (const [pattern, message] of [
      [/^(\d+(?:\.\d+)?) out of (\d+) stars?$/, '{0} out of {1} stars'],
      [/^(\d+(?:\.\d+)?) stars?$/, '{0} stars'],
      [/^(\d+) star review$/, '{0} stars'],
      [/^Average rating is (\d+(?:\.\d+)?)(?: stars?)?$/, 'Average rating is {0}'],
      [/^(\d+)% \((\d+)\) reviews with (\d+) star rating$/, '{0}% ({1}) reviews with {2} star rating'],
      [/^Go to page (\d+)$/, 'Go to page {0}'],
      [/^Go to item (\d+)$/, 'Go to item {0}'],
      [/^Thumbnails for (\d+) items$/, 'Thumbnails for {0} items'],
      [/^View (.+) product page$/, 'View {0} product page'],
    ]) {
      const match = pattern.exec(text);
      if (match) return translate(message, match.slice(1));
    }
    return translate(text);
  }
  function handleFor(element) {
    const href = element.getAttribute('href') || '';
    const fromUrl = /\/products\/([^/?#]+)/.exec(href)?.[1];
    const fromTitle = element.textContent.replace(/\s*Flavour\s*:\s*Liquid Concentrate.*$/i, '').trim()
      .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const candidate = fromUrl || fromTitle;
    return products?.[candidate] ? candidate : products?.[candidate.replace(/-sc$/, '')] ? candidate.replace(/-sc$/, '') : null;
  }
  function update() {
    pending = false;
    const widgets = Array.from(pendingWidgets);
    pendingWidgets.clear();
    for (const widget of widgets) {
      if (!root.contains(widget)) continue;
      // Only app chrome and authored product metadata. Customer quotations,
      // customer review titles and named reviewers are never translated.
      for (const element of widget.querySelectorAll('[aria-label], [title], [alt]')) {
        if (element.closest('.jdgm-rev__body, .jdgm-rev__title, .jm-review-body, .jm-review-title, blockquote')) continue;
        for (const name of ['aria-label', 'title', 'alt']) {
          const value = element.getAttribute(name);
          if (value) setAttribute(element, name, label(value));
        }
      }
      for (const element of widget.querySelectorAll('.jm-sort-filter label, .jm-reviewer-info__name, .jdgm-rev__author')) {
        const text = element.textContent.trim();
        if (text !== 'Sort reviews by' && text !== 'Anonymous') continue;
        element.textContent = translate(text);
      }
      const metadata = widget.querySelectorAll(metadataSelector);
      if (metadata.length && !productsRequest && source?.dataset.catalogue) {
        productsRequest = fetch(source.dataset.catalogue).then(response => {
          if (!response.ok) throw new Error('Catalogue labels unavailable');
          return response.json();
        }).then(data => { products = data; schedule(); }).catch(() => {});
      }
      for (const element of metadata) {
        if (!products) continue;
        const handle = element.dataset.wfProductHandle || handleFor(element);
        if (!handle) continue;
        const title = products[handle];
        const destination = routeRoot + 'products/' + handle;
        element.dataset.wfProductHandle = handle;
        if (element.textContent.trim() !== title) element.textContent = title;
        setAttribute(element, 'aria-label', translate('View {0} product page', [title]));
        if (element.matches('a')) setAttribute(element, 'href', destination);
        const card = element.closest('.jm-product-variant-card');
        const thumbnail = card?.querySelector('.jm-product-variant-card__thumbnail');
        if (thumbnail) {
          thumbnail.dataset.wfProductHandle = handle;
          setAttribute(thumbnail, 'aria-label', translate('View {0} product page', [title]));
          const image = thumbnail.querySelector('img');
          if (image) setAttribute(image, 'alt', title);
        }
      }
    }
  }
  function schedule(widget) {
    if (widget && !root.contains(widget)) return;
    if (widget) pendingWidgets.add(widget);
    else root.querySelectorAll(widgetSelector).forEach(widget => {
      if (!widget.parentElement.closest(widgetSelector)) pendingWidgets.add(widget);
    });
    if (pending || !pendingWidgets.size) return;
    pending = true;
    requestAnimationFrame(update);
  }
  function observeWidgets(node) {
    if (node.nodeType !== 1 || !root.contains(node) || node.parentElement?.closest(widgetSelector)) return;
    const widgets = node.matches(widgetSelector) ? [node] : node.querySelectorAll(widgetSelector);
    for (const widget of widgets) {
      if (widget.parentElement.closest(widgetSelector)) continue;
      if (!observedWidgets.has(widget)) {
        observedWidgets.add(widget);
        new MutationObserver(() => schedule(widget)).observe(widget, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['aria-label', 'title', 'alt', 'href'],
        });
      }
      schedule(widget);
    }
  }
  // The app's current product controls are buttons with Vue navigation handlers.
  // Route only these metadata controls to the French product, in a new tab as
  // the app does. Native review links keep their own normal link behaviour.
  function navigateMetadata(event) {
    const control = event.target.closest?.('.jm-product-variant-card [data-wf-product-handle][role="button"]');
    if (!control || !root.contains(control)) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.open(routeRoot + 'products/' + control.dataset.wfProductHandle, '_blank', 'noopener');
  }
  root.addEventListener('click', navigateMetadata, true);
  root.addEventListener('keydown', navigateMetadata, true);
  // Discover late or replaced widgets without rescanning reviews for other page changes.
  new MutationObserver(records => {
    for (const record of records) {
      if (!record.target.closest(widgetSelector)) record.addedNodes.forEach(observeWidgets);
    }
  }).observe(root, { childList: true, subtree: true });
  observeWidgets(root);
})();
